import { render, staticRenderFns } from "./63.vue?vue&type=template&id=4bf3a15e&scoped=true&"
var script = {}
import style0 from "./63.vue?vue&type=style&index=0&id=4bf3a15e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf3a15e",
  null
  
)

export default component.exports